
import React from 'react';
import { CheckCircle } from 'lucide-react';

export const ReportHighlights: React.FC = () => {
  return (
    <section className="mb-16">
      <h2 className="text-2xl md:text-3xl font-bold mb-6">What's Inside</h2>
      
      <div className="bg-gradient-to-br from-blue-900/30 to-indigo-900/30 p-6 rounded-lg border border-white/10">
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <CheckCircle className="h-6 w-6 text-primary mt-0.5 flex-shrink-0" />
            <p className="text-white/90">
              <span className="font-bold">Measurable Results:</span> Specific metrics and outcomes from 5 real-world case studies
            </p>
          </li>
          
          <li className="flex items-start gap-3">
            <CheckCircle className="h-6 w-6 text-primary mt-0.5 flex-shrink-0" />
            <p className="text-white/90">
              <span className="font-bold">Implementation Insights:</span> How these firms successfully deployed AI with minimal disruption
            </p>
          </li>
          
          <li className="flex items-start gap-3">
            <CheckCircle className="h-6 w-6 text-primary mt-0.5 flex-shrink-0" />
            <p className="text-white/90">
              <span className="font-bold">ROI Analysis:</span> Cost-benefit breakdown for each AI implementation
            </p>
          </li>
          
          <li className="flex items-start gap-3">
            <CheckCircle className="h-6 w-6 text-primary mt-0.5 flex-shrink-0" />
            <p className="text-white/90">
              <span className="font-bold">Strategic Framework:</span> A model for evaluating which AI tools will deliver the most value for your practice
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default ReportHighlights;
